// extracted by mini-css-extract-plugin
export default {"block":"_c","image":"ad","item":"bd","error":"cd"};